import { graphql } from 'react-relay';

export const linkGroupFragment = graphql`
    fragment LinkGroup_frontGroup on LinkGroup {
        title
        links {
            ...TaglineLink_tagLineLink
        }
    }
`;
